
import Chart from 'chart.js'

Chart.defaults.CChartBarRounded = Chart.defaults.bar
Chart.controllers.CChartBarRounded = Chart.controllers.bar.extend({
  draw: function (ease) {
    Chart.controllers.bar.prototype.draw.call(this, ease)
    const meta = this.getMeta()
    const datasets = meta.data
    const data = meta.controller._data
    datasets.forEach((bar, index) => {
      if (data[index] <= 0) return
      const { x, y, width, backgroundColor } = bar._view
      const radius = width / 2
      var ctx = this.chart.chart.ctx
      ctx.save()
      ctx.fillStyle = backgroundColor
      ctx.beginPath()
      ctx.arc(x, y, radius, 2 * Math.PI, 0)
      ctx.fill()
      ctx.restore()
    })
  }
})

const linearScale = Chart.scaleService.getScaleConstructor('linear')
const extendedScale = linearScale.extend({
  draw: function (chartArea) {
    linearScale.prototype.draw.call(this, chartArea)
    const { ctx } = this
    const { left, bottom } = chartArea
    ctx.save()
    ctx.strokeStyle = this.options.gridLines.zeroLineColor
    ctx.lineWidth = this.options.gridLines.zeroLineWidth
    ctx.beginPath()
    ctx.moveTo(left, 0)
    ctx.lineTo(left, bottom)
    ctx.stroke()
  }
})

Chart.scaleService.registerScaleType('extendedScale', extendedScale)
